jQuery( document ).ready(function() {
    /**
     * Obtiene el parámetro jose de la url
     */
    function obtener_parametro_url(sParam){
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++){
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam){
                return sParameterName[1];
            }
        }
    }

    /**
     * Setea la cookie
     * @param name
     * @param value
     * @param days
     */
    function setCookie(nombre,valor,horas) {
        var expires = "";
        if (horas) {
            var date = new Date();
            date.setTime(Date.now() + (horas*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = nombre + "=" + (valor || "")  + expires + "; path=/";
    }

    /**
     * Obtiene la cookie
     * @param name
     * @returns {*}
     */
    function obtenerCookie(nombre) {
        var nameEQ = nombre + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    /**
     * Borra la cookie
     * @param name
     */
    function borrarCookie(nombre) {
        document.cookie = nombre+'=; Max-Age=-99999999;';
    }

    if(obtener_parametro_url('traveltool') == '1' || obtenerCookie('brandeado') == 'traveltool'){
        setCookie('brandeado','traveltool',0);

        if (document.getElementById("shopify-section-header-producto") !=null){


            // Si es producto
            if(jQuery('.header-producto').length){
                var cabecera = jQuery('#shopify-section-header-producto header.header-producto');
                var mensaje = '<div class="contenedor-principal header-principal">' +
                    '<div class="logo">' +
                    '<div>' +
                    '<a href="/" class="logo-image">' +
                    '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/Logo_color_corporativo_150x_2x_2a74793a-79e3-49ce-a760-2cd0f6016eb9.png?v=1550825986" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/Logo_color_corporativo_150x_2x_2a74793a-79e3-49ce-a760-2cd0f6016eb9.png?v=1550825986" alt="Holafy">' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '<div class="logo-iberia">' +
                    '<div>' +
                    '<a href="/" class="logo-image">' +
                    '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/traveltool_logo_134x134_crop_center@2x.jpg?v=1573607034" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/traveltool_logo_134x134_crop_center@2x.jpg?v=1573607034">' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '<div class="slogan-iberia">' +
                    '<span>' + 'No pagues Roaming</span>' +
                    '</div>' +
                    '</div>';
            }else{
                var cabecera = jQuery('#shopify-section-header-producto header');
                var menu = jQuery('.menu-top.solo-escritorio');
                var icono_menu = jQuery('.icono-menu');
                var mensaje = '<div class="contenedor-principal header-principal">' +
                    '<div class="icono-menu solo-movil">' +
                    '<span>&#9776;</span>' +
                    '</div>' +
                    '<div class="logo">' +
                    '<div>' +
                    '<a href="/" class="logo-image">' +
                    '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/Logo_color_corporativo_150x_2x_2a74793a-79e3-49ce-a760-2cd0f6016eb9.png?v=1550825986" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/Logo_color_corporativo_150x_2x_2a74793a-79e3-49ce-a760-2cd0f6016eb9.png?v=1550825986" alt="Holafy">' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '<div class="logo-iberia">' +
                    '<div>' +
                    '<a href="/" class="logo-image">' +
                    '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/traveltool_logo_134x134_crop_center@2x.jpg?v=1573607034" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/traveltool_logo_134x134_crop_center@2x.jpg?v=1573607034">' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    menu.prop('outerHTML') +
                    '</div>';
            }


            var slide = document.getElementById("carrusel-imagenes");

            mensaje += '<style>' +
                'body{ font-family: "Ubuntu"; }' +
                //'#shopify-section-header-producto{ box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.27); }' +
                'body .logo img, body .logo-iberia img{ max-width: 150px; }' +
                'body .txt-item-tarjeta > p:first-child { margin-top: 0; margin-bottom: 10px; /*color: #02a198;*/ }' +
                'body .descripcion-producto p strong{/*color: #02a198;*/font-weight: 300;}' +
                'body .elemento-saber > div:last-child > p:first-child{/*color: #02a198;*/font-size: 16px;}' +
                'body .subtitulo-contiene > div > p:first-child {/*color: #02a198;*/}' +
                'body .logo {border-right: solid 1px #f2f3f4;padding-right: 24px;}' +
                'body .logo-iberia{padding-left: 24px;}' +
                'body .header-producto .logo img, body .header-producto .logo-iberia img{max-width: 146px;}' +
                'body .slogan-iberia {display: flex;flex: 1;justify-content: flex-end;align-items: center;color: #646c80;font-size: 23px;}' +
                'img.icono-incl {/*background: #02a198;*/}' +
                '.elemento-saber > div:first-child img {filter: hue-rotate(418deg);}' +
                '.elemento-enlinea h3{/*color: #02a198;*/}' +
                '.tabs .checkboxtab:checked ~ label, .tabs-mix .checkboxtab:checked ~ label {/*border: 3px solid #02a198;color: #02a198;*/}' +
                '.accordion-item-hd{/*border-bottom: 2px solid #02a198;*/}' +
                '@media only screen and (max-width: 1130px) {' +
                '.body-home .logo-image > img{ max-width: 90px!important; }' +
                '.body-home .header-principal{ justify-content: space-between; }' +
                '.body-home .header-principal > div.logo{ width: auto; border-right: none; }' +
                '}' +
                '</style>';
            cabecera.html(mensaje);
            if (document.getElementById("carrusel-imagenes") !=null){
                slide.innerHTML = "";
            }

            jQuery(document).on('click', '.icono-menu', function() {
                jQuery('#menu-movil').toggle();
            });

            jQuery(document).on('click', '.cerrar-mov', function() {
                jQuery('#menu-movil').toggle();
            });
        }else if(jQuery('.header-producto .logo').length){
            var logo = '<div>\n' +
                '<a href="/" class="logo-image">\n' +
                '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/traveltool_logo_134x134_crop_center@2x.jpg?v=1573607034" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/traveltool_logo_134x134_crop_center@2x.jpg?v=1573607034">' +
                '</a>\n' +
                '</div>';
            var estilos = '<style>' +
                    '.logo-image img{ max-width: 150px; }' +
                    '.logo{ display: flex; justify-content: center; align-items: center; }'
                    '</style>';
            jQuery('.header-producto .logo').append(logo);
            jQuery('body').append(estilos);
        }
    }

    // Para brandeado iati

    /*if (obtener_parametro_url("iati") == '1' || obtenerCookie('brandeado') == 'iati' && obtener_parametro_url("logitravel") != '1' && obtener_parametro_url("edreams") != '1' && obtener_parametro_url("iberia") != '1') {

        setCookie('brandeado','iati',0);

        if (document.getElementById("shopify-section-header-producto") !=null){


            // Si es producto
            if(jQuery('.header-producto').length){
                var cabecera = jQuery('#shopify-section-header-producto header.header-producto');
                var mensaje = '<div class="contenedor-principal header-principal">' +
                    '<div class="logo">' +
                    '<div>' +
                    '<a href="/" class="logo-image">' +
                    '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/Logo_color_corporativo_150x_2x_2a74793a-79e3-49ce-a760-2cd0f6016eb9.png?v=1550825986" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/Logo_color_corporativo_150x_2x_2a74793a-79e3-49ce-a760-2cd0f6016eb9.png?v=1550825986" alt="Holafy">' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '<div class="logo-iberia">' +
                    '<div>' +
                    '<a href="/" class="logo-image">' +
                    '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/iati-logo-hfly.jpg?14341" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/iati-logo-hfly.jpg?14341">' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '<div class="slogan-iberia">' +
                    '<span>' + 'No pagues Roaming</span>' +
                    '</div>' +
                    '</div>';
            }else{
                var cabecera = jQuery('#shopify-section-header-producto header');
                var menu = jQuery('.menu-top.solo-escritorio');
                var icono_menu = jQuery('.icono-menu');
                var mensaje = '<div class="contenedor-principal header-principal">' +
                    '<div class="icono-menu solo-movil">' +
                    '<span>&#9776;</span>' +
                    '</div>' +
                    '<div class="logo">' +
                    '<div>' +
                    '<a href="/" class="logo-image">' +
                    '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/Logo_color_corporativo_150x_2x_2a74793a-79e3-49ce-a760-2cd0f6016eb9.png?v=1550825986" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/Logo_color_corporativo_150x_2x_2a74793a-79e3-49ce-a760-2cd0f6016eb9.png?v=1550825986" alt="Holafy">' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '<div class="logo-iberia">' +
                    '<div>' +
                    '<a href="/" class="logo-image">' +
                    '<img src="https://cdn.shopify.com/s/files/1/2347/1879/files/iati-logo-hfly.jpg?14341" srcset="https://cdn.shopify.com/s/files/1/2347/1879/files/iati-logo-hfly.jpg?14341">' +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    menu.prop('outerHTML') +
                    '</div>';
            }


            var slide = document.getElementById("carrusel-imagenes");

            mensaje += '<style>' +
                'body{ font-family: "Ubuntu"; }' +
                //'#shopify-section-header-producto{ box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.27); }' +
                'body .logo img, body .logo-iberia img{ max-width: 150px; }' +
                'body .txt-item-tarjeta > p:first-child { margin-top: 0; margin-bottom: 10px; color: #FF9900; }' +
                'body .descripcion-producto p strong{color: #FF9900;font-weight: 300;}' +
                'body .elemento-saber > div:last-child > p:first-child{color: #FF9900;font-size: 16px;}' +
                'body .subtitulo-contiene > div > p:first-child {color: #FF9900;}' +
                'body .logo {border-right: solid 1px #f2f3f4;padding-right: 24px;}' +
                'body .logo-iberia{padding-left: 24px;}' +
                'body .header-producto .logo img, body .header-producto .logo-iberia img{max-width: 146px;}' +
                'body .slogan-iberia {display: flex;flex: 1;justify-content: flex-end;align-items: center;color: #646c80;font-size: 23px;}' +
                'img.icono-incl {background: #FF9900;}' +
                '.elemento-saber > div:first-child img {filter: hue-rotate(418deg);}' +
                '.elemento-enlinea h3{color: #FF9900;}' +
                '.tabs .checkboxtab:checked ~ label, .tabs-mix .checkboxtab:checked ~ label {border: 3px solid #FF9900;color: #FF9900;}' +
                '.accordion-item-hd{border-bottom: 2px solid #FF9900;}' +
                '</style>';
            cabecera.html(mensaje);
            if (document.getElementById("carrusel-imagenes") !=null){
                slide.innerHTML = "";
            }

            jQuery(document).on('click', '.icono-menu', function() {
                jQuery('#menu-movil').toggle();
            });

            jQuery(document).on('click', '.cerrar-mov', function() {
                jQuery('#menu-movil').toggle();
            });
        }

    }*/
});